// @generated by TypeGen from LogbookModel/Lighting.swift - DO NOT EDIT

export enum ILogLighting {
  none,
  triColorLights,
  anchorBall,
  anchorLight,
  sailingRunningLights,
  motoringRunningLights,
  motoringCone,
}

export enum ISailingLightsMode {
  runningLights,
  triColor,
}
